export class DialogController {
  open: () => void | Promise<void> = () => {};
  close: () => void | Promise<void> = () => {};
}
